export const connectionManager = (() => {
  let connection = null; // Private variable, not exposed

  return {
    getConnection() {
      return connection;
    },
    setConnection(newConnection) {
      // Close the existing connection if it is open
      if (connection) {
        if (connection.connection.state !== "closed") {
          connection.close();
        }
      }
      connection = newConnection;
    },
  };
})();
